import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { GenerarInformeDicomDto } from "../interfaces";


const generarCertificadoDicom = async (body: GenerarInformeDicomDto): Promise<any> => {

    try {
        const response: AxiosResponse = await axiosInstance.post(`siscred-api-reportes/v1/archivo-externo/informe-dicom`, body);
        return response;
    } catch (error) {
        throw error;
    }
}

export {
    generarCertificadoDicom,
};
